import { AtlSelectOption } from './props';

export class AtlSelectPreviousSearchEvent extends Event {
   static readonly EVENT_NAME = 'onprevioussearch';
   constructor() {
      super(AtlSelectPreviousSearchEvent.EVENT_NAME, {
         bubbles: true,
         composed: true,
      });
   }
}

export class AtlSelectKeyDownEvent extends CustomEvent<{ payload: string }> {
   static readonly EVENT_NAME = 'onkeydown';
   constructor(value: string) {
      super(AtlSelectKeyDownEvent.EVENT_NAME, {
         detail: { payload: value },
         bubbles: true,
         composed: true,
      });
   }
}

export class AtlSelectChangeEvent extends CustomEvent<{
   payload: string | AtlSelectOption | AtlSelectOption[] | undefined;
}> {
   static readonly EVENT_NAME = 'onchange';
   constructor(
      value:
         | string
         | AtlSelectOption
         | AtlSelectOption[]
         | undefined = undefined
   ) {
      super(AtlSelectChangeEvent.EVENT_NAME, {
         detail: { payload: value },
         bubbles: true,
         composed: true,
      });
   }
}
